export default "__VITE_ASSET__e4ab1649__"